import { render, staticRenderFns } from "./TestImports.vue?vue&type=template&id=d9a082a4&scoped=true&"
import script from "./TestImports.vue?vue&type=script&lang=js&"
export * from "./TestImports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a082a4",
  null
  
)

export default component.exports